import { render, staticRenderFns } from "./table2.vue?vue&type=template&id=890d7440&"
import script from "./table2.vue?vue&type=script&lang=ts&"
export * from "./table2.vue?vue&type=script&lang=ts&"
import style0 from "./table2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports